<template>
    <div class="row no-gutters" :key="'add'">
        <div class="col-md-12 bg-light pointer pl-2">
            <span class="text-success" @click="$refs.addMemberToGroupModal.open()">
                <i class="fa fa-plus"></i> Add Member
            </span>
        </div>

        <!-- Add member dialog -->
        <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_ADD_MEMBER_MODAL_TITLE', {name: this.group.name})" ref="addMemberToGroupModal">
            <div class="form-group">
                <label for="name">{{ $t('UI_INSTANCE_MEMBER_GROUP_MEMBER_NAME') }}</label>
                <input type="text" id="name" v-model="member.name" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_NAME')" class="form-control" v-on:keyup.enter="addMemberToGroup">
            </div>

            <div class="form-group">
                <label for="description">{{ $t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DESCRIPTION') }}</label>
                <input type="text" id="description" v-model="member.description" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DESCRIPTION')" class="form-control" v-on:keyup.enter="addMemberToGroup">
            </div>


            <div slot="button">
                <button class="btn btn-primary" @click="addMemberToGroup">
                    {{ $t("UI_MODAL_BUTTON_SAVE") }}
                </button>
                <button class="btn btn-secondary ml-1" @click="$refs.addMemberToGroupModal.close()">
                    {{ $t("UI_MODAL_BUTTON_CLOSE") }}
                </button>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

const InstanceMemberRepository = RepositoryFactory.get('instanceMembers');

export default {
  name: 'InstanceMemberAdd',
  props: ['group'],
  components: { SweetModal },
  data() {
    return {
      member: {
        name: '',
        description: null,
      },
    };
  },
  methods: {
    /**
       * Adds the member to the selected group.
       */
    async addMemberToGroup() {
      await InstanceMemberRepository.addMember(this.member.name, this.group.id, this.member.description)
        .then(() => {
          this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_ADDED', {
            member: this.member.name,
            group: this.group.name,
          }));
          InstanceMemberRepository.refetchMemberList();

          this.member.name = '';
          this.member.description = null;
          this.$refs.addMemberToGroupModal.close();
        });
    },
  },
};
</script>

<style scoped>

</style>
